/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateSFMChildPositionV1Dto } from '../models/CreateSFMChildPositionV1Dto';
import type { CreateSFMParentPositionV1Dto } from '../models/CreateSFMParentPositionV1Dto';
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { PatchSFMChildPositionV1Dto } from '../models/PatchSFMChildPositionV1Dto';
import type { PatchSFMParentPositionV1Dto } from '../models/PatchSFMParentPositionV1Dto';
import type { SFMChildPositionV1Dto } from '../models/SFMChildPositionV1Dto';
import type { SFMParentPositionV1Dto } from '../models/SFMParentPositionV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SfmPositionsService {
  /**
   * List all SFM Positions with SubPositions
   * @returns SFMParentPositionV1Dto a entity list
   * @throws ApiError
   */
  public static sfmParentPositionControllerV1FindAllV1(): CancelablePromise<
    Array<SFMParentPositionV1Dto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/sfm-positions',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * Create SFM Position
   * @param requestBody
   * @returns SFMParentPositionV1Dto create entity
   * @throws ApiError
   */
  public static sfmParentPositionControllerV1CreateV1(
    requestBody: CreateSFMParentPositionV1Dto,
  ): CancelablePromise<SFMParentPositionV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/sfm-positions',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * Delete many operating cost invoices
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static sfmParentPositionControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/sfm-positions',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * Get SFM Position by ID
   * @param id SFM Position ID (UUID v4)
   * @returns SFMParentPositionV1Dto the entity
   * @throws ApiError
   */
  public static sfmParentPositionControllerV1FindOneV1(
    id: string,
  ): CancelablePromise<SFMParentPositionV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/sfm-positions/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * Update SFM Position
   * @param id SFM Position ID (UUID v4)
   * @param requestBody
   * @returns SFMParentPositionV1Dto the update entity
   * @throws ApiError
   */
  public static sfmParentPositionControllerV1UpdatePartialV1(
    id: string,
    requestBody: PatchSFMParentPositionV1Dto,
  ): CancelablePromise<SFMParentPositionV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/sfm-positions/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * Delete SFM Position
   * @param id SFM Position ID (UUID v4)
   * @returns SFMParentPositionV1Dto the entity
   * @throws ApiError
   */
  public static sfmParentPositionControllerV1RemoveOneV1(
    id: string,
  ): CancelablePromise<SFMParentPositionV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/sfm-positions/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * Get all parents child Positions
   * @param parentId Parent SFM Position ID (UUID v4)
   * @returns SFMChildPositionV1Dto a entity list
   * @throws ApiError
   */
  public static sfmChildPositionControllerV1FindAllV1(
    parentId: string,
  ): CancelablePromise<Array<SFMChildPositionV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/sfm-positions/{parentId}/child',
      path: {
        parentId: parentId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * Add Child Position to Parent
   * @param parentId Parent SFM Position ID (UUID v4)
   * @param requestBody
   * @returns SFMChildPositionV1Dto create entity
   * @throws ApiError
   */
  public static sfmChildPositionControllerV1CreateV1(
    parentId: string,
    requestBody: CreateSFMChildPositionV1Dto,
  ): CancelablePromise<SFMChildPositionV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/sfm-positions/{parentId}/child',
      path: {
        parentId: parentId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * Delete many child position
   * @param parentId Parent SFM Position ID (UUID v4)
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static sfmChildPositionControllerV1RemoveManyV1(
    parentId: string,
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/sfm-positions/{parentId}/child',
      path: {
        parentId: parentId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * Get Child Position
   * @param parentId Parent SFM Position ID (UUID v4)
   * @param childId Child SFM Position ID (UUID v4)
   * @returns SFMChildPositionV1Dto the entity
   * @throws ApiError
   */
  public static sfmChildPositionControllerV1FindOneV1(
    parentId: string,
    childId: string,
  ): CancelablePromise<SFMChildPositionV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/sfm-positions/{parentId}/child/{childId}',
      path: {
        parentId: parentId,
        childId: childId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * Update Child Position
   * @param parentId Parent SFM Position ID (UUID v4)
   * @param childId Child SFM Position ID (UUID v4)
   * @param requestBody
   * @returns SFMChildPositionV1Dto the update entity
   * @throws ApiError
   */
  public static sfmChildPositionControllerV1UpdatePartialV1(
    parentId: string,
    childId: string,
    requestBody: PatchSFMChildPositionV1Dto,
  ): CancelablePromise<SFMChildPositionV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/sfm-positions/{parentId}/child/{childId}',
      path: {
        parentId: parentId,
        childId: childId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * Delete Child Position
   * @param parentId Parent SFM Position ID (UUID v4)
   * @param childId Child SFM Position ID (UUID v4)
   * @returns SFMChildPositionV1Dto the entity
   * @throws ApiError
   */
  public static sfmChildPositionControllerV1RemoveOneV1(
    parentId: string,
    childId: string,
  ): CancelablePromise<SFMChildPositionV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/sfm-positions/{parentId}/child/{childId}',
      path: {
        parentId: parentId,
        childId: childId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
}
